import * as React from 'react';
import { EGDSHeading, EGDSText } from '@egds/react-core/text';
import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSMark, EGDSMarkSize } from '@egds/react-core/mark';
import { HeaderGuestHeadingActions } from './header-guest-heading-actions';
export var HeaderAccountMenuOneKey = function (_a) {
  var globalComponentsContext = _a.globalComponentsContext,
    buttons = _a.buttons,
    buttonsKeysPosition = _a.buttonsKeysPosition,
    gssSigninRedirectParam = _a.gssSigninRedirectParam,
    context = _a.context;
  var _b = globalComponentsContext.header.oneKey.oneKeyAccountMenu,
    oneKeyHeading = _b.oneKeyHeading,
    oneKeySubHeading = _b.oneKeySubHeading,
    oneKeyLearnMoreLink = _b.oneKeyLearnMoreLink,
    oneKeySignInReferrerId = _b.oneKeySignInReferrerId,
    oneKeyAccountMenuLogoImgSrcsAsObj = _b.oneKeyAccountMenuLogoImgSrcsAsObj,
    oneKeyAccountMenuImpressionReferrerId = _b.oneKeyAccountMenuImpressionReferrerId,
    oneKeyLinkName = _b.oneKeyLinkName;
  var modifyOneKeyContentButtons = function () {
    var signInButton = buttons[buttonsKeysPosition['account-signin']];
    signInButton.trackingEvent = oneKeySignInReferrerId;
    signInButton.linkName = oneKeyLinkName;
    if ((oneKeyLearnMoreLink === null || oneKeyLearnMoreLink === void 0 ? void 0 : oneKeyLearnMoreLink.url) && (oneKeyLearnMoreLink === null || oneKeyLearnMoreLink === void 0 ? void 0 : oneKeyLearnMoreLink.text)) {
      var learnAbtOneKeyButton = buttons[buttonsKeysPosition['account-register']];
      learnAbtOneKeyButton.url = oneKeyLearnMoreLink.url;
      learnAbtOneKeyButton.trackingEvent = oneKeyLearnMoreLink.omnitureId;
      learnAbtOneKeyButton.trackingEvent = oneKeyLinkName;
      learnAbtOneKeyButton.id = oneKeyLinkName;
      learnAbtOneKeyButton.text = oneKeyLearnMoreLink.text;
      learnAbtOneKeyButton.skipRedirectGss = true;
    }
  };
  modifyOneKeyContentButtons();
  return React.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: oneKeyAccountMenuImpressionReferrerId,
    linkName: oneKeyLinkName
  }, React.createElement("div", {
    className: "header-guest-heading"
  }, React.createElement("div", {
    className: "heading-container one-key-account-menu"
  }, oneKeyHeading && React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'two'
    }
  }, React.createElement(EGDSHeading, {
    tag: "h4",
    size: 4,
    align: "center"
  }, oneKeyHeading)), oneKeySubHeading && React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'four'
    }
  }, React.createElement(EGDSText, {
    align: "center",
    weight: "medium",
    size: 500,
    className: "one-key-sub-heading-text"
  }, oneKeySubHeading)), React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'six'
    }
  }, React.createElement(EGDSLayoutFlex, {
    space: "three",
    justifyContent: "center"
  }, oneKeyAccountMenuLogoImgSrcsAsObj && oneKeyAccountMenuLogoImgSrcsAsObj.map(function (_a) {
    var imgSrc = _a.imgSrc,
      altText = _a.altText;
    return React.createElement(EGDSMark, {
      key: altText,
      url: imgSrc,
      description: altText,
      size: EGDSMarkSize.EXTRA_SMALL
    });
  }))), React.createElement(HeaderGuestHeadingActions, {
    gssSigninRedirectParam: gssSigninRedirectParam,
    buttons: buttons,
    context: context
  }))));
};
HeaderAccountMenuOneKey.displayName = 'HeaderAccountMenuOneKey';